// Libraries
import { Card, Flex, Link, Text } from '@chakra-ui/react';
// Components
import { HourGlassIcon } from '@atoms/index';
// Utils
import { AppPath } from '@constants/index';
import text from '@translations/en.json';

/**
 * Renders a card component for an expired link.
 * @component
 * @returns {ReactElement} The ExpiredLinkCard component.
 */
export const ExpiredLinkCard = () => {
  return (
    <Card p={10} align='flex-start' gap={8} maxW='fit-content'>
      <HourGlassIcon w={11} h={10} />
      <Flex direction='column' gap={3}>
        <Text fontSize='hs' fontWeight='semibold'>
          {text.expired_link_title}
        </Text>
        <Text fontSize='m'>{text.expired_link_subtitle}</Text>
      </Flex>
      <Link variant='forms' href={AppPath.LOGIN}>
        {text.log_in}
      </Link>
    </Card>
  );
};
